module.exports = "/_next/static/images/planner-c0d56f7b5ac5bc11660e7dc174a5467e.svg";